// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__hT3IM","fx":"tag_fx__nM8qW","etf":"tag_etf__Sz5Mf","cfd":"tag_cfd__JHlNK","other":"tag_other__KjPft"};